interface Props {
  size?: number;
  className?: string;
  title?: string;
}

/** Outer rim radius / viewBox size (104 / 256) — used to align with the projected real handwheel. */
export const OPEN_ROTOR_RIM = 104 / 256;

/**
 * NORTHLINE Open Rotor A — approved brand mark. Geometry copied verbatim from the brand kit SVG.
 * Colour: #BA332A by default (pass `fill="currentColor"` style via className if needed).
 */
export default function OpenRotorMark({ size = 32, className = '', title }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      width={size}
      height={size}
      className={`shrink-0 ${className}`}
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
    >
      {title && <title>{title}</title>}
      <g fill="#BA332A">
        <path d="M228.46 154.92 A104 104 0 0 1 101.08 228.46 L107.29 205.27 A80 80 0 0 0 205.27 148.71 Z" />
        <path d="M54.46 201.54 A104 104 0 0 1 54.46 54.46 L71.43 71.43 A80 80 0 0 0 71.43 184.57 Z" />
        <path d="M101.08 27.54 A104 104 0 0 1 228.46 101.08 L205.27 107.29 A80 80 0 0 0 107.29 50.73 Z" />
        <path d="M152 135 L152 121 L208 121 L208 135 Z" />
        <path d="M109.94 145.28 L122.06 152.28 L94.06 200.78 L81.94 193.78 Z" />
        <path d="M122.06 103.72 L109.94 110.72 L81.94 62.22 L94.06 55.22 Z" />
        <path fillRule="evenodd" d="M128 94 L157 111 L157 145 L128 162 L99 145 L99 111 Z M128 111 L113 120 L113 137 L128 146 L143 137 L143 120 Z" />
      </g>
    </svg>
  );
}